/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type co_getplato_grid_sales_features_order_list_OrderCreatedAtDate = {
    date_time: string;
    comparison: co_getplato_grid_sales_features_order_list_OrderCreatedAtDate.comparison;
};
export namespace co_getplato_grid_sales_features_order_list_OrderCreatedAtDate {
    export enum comparison {
        LTE = 'LTE',
        GTE = 'GTE',
        EQ = 'EQ',
    }
}

